import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/laboratorio';
import ReporteNh3Vfa from './ReporteNh3Vfa';

const ms2p = state => {
    return {
        ...state.laboratorio,
        proveedor: state.login.proveedor,
        me: state.login.me,
    }
}

const md2p = { ...actions };

export default connect(ms2p, md2p)(ReporteNh3Vfa);